import React from "react";

const StepRegularIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("rect", {
  x: 2,
  y: 3,
  width: 16,
  height: 14,
  rx: 2,
  stroke: "currentColor",
  strokeWidth: 1.1,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("line", {
  x1: 4.55,
  y1: 13.45,
  x2: 9.45,
  y2: 13.45,
  stroke: "currentColor",
  strokeWidth: 1.1,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("line", {
  x1: 2.55,
  y1: 10.45,
  x2: 17.45,
  y2: 10.45,
  stroke: "currentColor",
  strokeWidth: 1.1,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(StepRegularIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;